import { CoreUiException } from "./core-ui-exception";

/**
 * Occurs when an error occurs in the ListDataSource
 * @see ListDataSource
 */
export class ListDataSourceException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("ListDataSourceError", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ListDataSourceException.prototype);
    }
}
